import { render, staticRenderFns } from "./SpotifyItemSelector.vue?vue&type=template&id=3f9c17d1&"
import script from "./SpotifyItemSelector.vue?vue&type=script&lang=ts&"
export * from "./SpotifyItemSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports